export const EMPTY_DRUM_ACCEPTED = 'EMPTY_DRUM_ACCEPTED'
// export const EMPTY_DRUM_WITH_CABLE_ACCEPTED = 'EMPTY_DRUM_WITH_CABLE_ACCEPTED';
export const DRUM_WITH_CABLE_ACCEPTED = 'DRUM_WITH_CABLE_ACCEPTED'
